import React, { Suspense } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import ExplorerPage from './pages/ExplorerPage';
import LoginPage from './pages/LoginPage';
import SubmitPage from './pages/SubmitPage';
import RecipeDetailPage from './pages/RecipeDetailPage';
import FavoritesPage from './pages/FavoritesPage';
import ArticlesPage from './pages/ArticlesPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import ArticleEditorPage from './pages/ArticleEditorPage';
import PreferencesPage from './pages/PreferencesPage';
import AppLayout from './components/layout/AppLayout';
import { LanguageProvider } from './i18n/LanguageContext';

const FoodDiaryPage = React.lazy(() => import('./pages/FoodDiaryPage'));

const LANG_PREF_KEY = 'pninit-lang-pref';

const isBrowserHebrew = () => {
  const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
  return langs.some((l) => l.toLowerCase().startsWith('he'));
};

/** Call this when the user explicitly picks a language. */
const setLangPref = (lang) => sessionStorage.setItem(LANG_PREF_KEY, lang);

/** Returns the stored explicit preference, or null on first visit. */
const getLangPref = () => sessionStorage.getItem(LANG_PREF_KEY);

export { isBrowserHebrew, setLangPref, getLangPref };

const pageRoutes = (
  <>
    <Route path="" element={<HomePage />} />
    <Route path="explorer" element={<ExplorerPage />} />
    <Route path="favorites" element={<FavoritesPage />} />
    <Route path="recipes/:recipeId" element={<RecipeDetailPage />} />
    <Route path="login" element={<LoginPage />} />
    <Route path="submit" element={<SubmitPage />} />
    <Route path="articles" element={<ArticlesPage />} />
    <Route path="articles/:articleId" element={<ArticleDetailPage />} />
    <Route path="admin/articles/new" element={<ArticleEditorPage />} />
    <Route path="admin/articles/:articleId/edit" element={<ArticleEditorPage />} />
    <Route path="preferences" element={<PreferencesPage />} />
    <Route
      path="diary"
      element={
        <Suspense fallback={<div style={{ padding: '2rem', textAlign: 'center' }}>Loading…</div>}>
          <FoodDiaryPage />
        </Suspense>
      }
    />
  </>
);

const App = () => (
  <HashRouter>
    <Routes>
      {/* English (LTR) */}
      <Route
        element={
          <LanguageProvider lang="en">
            <AppLayout />
          </LanguageProvider>
        }
      >
        <Route path="/">{pageRoutes}</Route>
      </Route>

      {/* Hebrew (RTL) */}
      <Route
        element={
          <LanguageProvider lang="he">
            <AppLayout />
          </LanguageProvider>
        }
      >
        <Route path="/heb">{pageRoutes}</Route>
      </Route>
    </Routes>
  </HashRouter>
);

export default App;
